// extracted by mini-css-extract-plugin
module.exports = {"card":"CourseCardBase_card__xHrY3","disabled":"CourseCardBase_disabled__3LJXv","disabledOverlay":"CourseCardBase_disabledOverlay__2jQLE"};